interface ProfileFieldProps {
  label: string
  value: string | undefined
  className?: string
}

export const ProfileField = ({
  label,
  value,
  className,
}: ProfileFieldProps) => {
  // Convert label to kebab-case for use in data-testid
  const kebabLabel = label.toLowerCase().replace(/\s+/g, '-')

  return (
    <div
      className={`grid grid-cols-2 py-3 ${className}`}
      data-testid={`container-profile-field-${kebabLabel}`}
    >
      <span
        className="font-normal text-gray-700 dark:text-white"
        data-testid={`text-profile-field-label-${kebabLabel}`}
      >
        {label}:
      </span>
      <span
        className="text-gray-900 dark:text-white break-words"
        data-testid={`text-profile-field-value-${kebabLabel}`}
      >
        {value}
      </span>
    </div>
  )
}
